(function () {
  'use strict';
  function emit(name, properties) {
    if (window.TPGRevenue) window.TPGRevenue.emit(name, properties || {});
  }
  var collection = document.querySelector('[data-merch-collection]');
  if (collection) emit('revenue_collection_view', { collection: collection.dataset.merchCollection });
  var product = document.querySelector('[data-merch-product]');
  if (product) emit('revenue_product_view', { product_id: product.dataset.productId, package_id: product.dataset.packageId || null, tier_selection: product.dataset.tierSelection || null, collection: product.dataset.collection || null });
  document.addEventListener('click', function (event) {
    var target = event.target.closest('[data-merch-event]');
    if (target) emit('revenue_' + target.dataset.merchEvent, { product_id: target.closest('[data-product-id]')?.dataset.productId || null, package_id: target.dataset.packageId || target.closest('[data-package-id]')?.dataset.packageId || null, tier_selection: target.closest('[data-tier-selection]')?.dataset.tierSelection || null, collection: target.dataset.collectionId || target.closest('[data-merch-collection]')?.dataset.merchCollection || null });
    var thumbnail = event.target.closest('[data-gallery-image]');
    if (thumbnail) {
      var hero = document.querySelector('.merch-gallery__hero img');
      if (hero) { hero.src = thumbnail.dataset.galleryImage; hero.alt = thumbnail.dataset.galleryAlt || ''; }
      document.querySelectorAll('[data-gallery-image]').forEach(function (item) { item.setAttribute('aria-current', item === thumbnail ? 'true' : 'false'); });
    }
    var swatch = event.target.closest('[data-color-image]');
    if (swatch) {
      var image = document.querySelector('.merch-gallery__hero img');
      if (image && swatch.dataset.colorImage) { image.src = swatch.dataset.colorImage; image.alt = swatch.dataset.colorAlt || ''; }
      document.querySelectorAll('[data-color-image]').forEach(function (item) { item.setAttribute('aria-pressed', item === swatch ? 'true' : 'false'); });
      emit('revenue_color_selected', { product_id: product?.dataset.productId || null, color: swatch.dataset.colorName });
    }
  });
}());
